const mapsApiKey = 'AIzaSyCbKYeVX4cShpcdmOjFU7rYQtma0lKJxKo';
const mapStyles = [{featureType:"all",elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#333333"},{lightness:40}]},{featureType:"all",elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#ffffff"},{lightness:16}]},{featureType:"all",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#fefefe"},{lightness:20},{visibility:"on"}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#fefefe"},{lightness:17},{weight:1.2},{visibility:"on"}]},{featureType:"administrative",elementType:"labels",stylers:[{visibility:"on"}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#e8e5df"},{lightness:20},{visibility:"on"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:21}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#dedede"},{lightness:21},{visibility:"off"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#ffffff"},{lightness:17},{visibility:"off"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#ffffff"},{lightness:29},{weight:.2},{visibility:"off"}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:18},{visibility:"off"}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:16},{visibility:"off"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#f2f2f2"},{lightness:19},{visibility:"off"}]},{featureType:"water",elementType:"geometry",stylers:[{visibility:"on"},{color:"#c6dae7"},{lightness:"0"},{gamma:"1.00"}]}];
const userLocation = {
    lat: '',
    lng: ''
};

function loadScript(url) {
    return new Promise(function (resolve, reject) {
        const script = document.createElement('script');
        script.src = url;
        script.async = false;

        script.onload = function () {
            resolve(url);
        };

        script.onerror = function () {
            reject(url);
        };

        document.body.appendChild(script);
    });
}

/**
 * Fake pagination that shows the next 10 retailers.
 */
//function loadMarkers(event) {
function loadMarkers(mapObject) {
    const markersHidden = mapObject.mapContainer.querySelectorAll('[data-action="marker"].js-hide');
    const size = 10;

    for (let r = 0, rl = size; r < rl; r++) {
        if (markersHidden[r]) {
            markersHidden[r].classList.remove('js-hide');
        }
    }

    if (mapObject.markerSearchInput) {
        markersShown(mapObject.mapContainer);
    }
}

/**
 * Hides the "Load more"-button when all retailers are shown.
 */
function markersExtra(mapContainer) {
    const markersExtra = mapContainer.querySelectorAll('[data-action="marker"].js-hide:not(.js-hidden-search):not(.js-hidden-bounds)');

    if (markersExtra.length === 0) {
        mapContainer.querySelector('.retailers__list .retailers__list-more') ? mapContainer.querySelector('.retailers__list .retailers__list-more').classList.add('js-hide') : false;
    } else {
        mapContainer.querySelector('.retailers__list .retailers__list-more') ? mapContainer.querySelector('.retailers__list .retailers__list-more').classList.remove('js-hide') : false;
    }
}

/**
 * Shows a "No results"-message if no retailers match the search or inside map bounds.
 */
function markersShown(mapContainer) {
    const markersShown = mapContainer.querySelectorAll('[data-action="marker"]:not(.js-hidden-search):not(.js-hidden-bounds)');

    if (markersShown.length === 0) {
        mapContainer.querySelector('.retailers__list .retailers__no-results') ? mapContainer.querySelector('.retailers__list .retailers__no-results').classList.remove('js-hide') : false;
    } else {
        mapContainer.querySelector('.retailers__list .retailers__no-results') ? mapContainer.querySelector('.retailers__list .retailers__no-results').classList.add('js-hide') : false;
    }

    markersExtra(mapContainer);
}

/**
 * Simple search to match 1:1 what the user has typed. Once search is intiated all retailers are shown (if inside map bounds).
 */
function markerSearch(mapObject) {
    const filterValue = mapObject.markerSearchInput.value;
    const markersNew = [];

    mapObject.markerElements.forEach(markerElement => {
        const marker = mapObject.markers.filter(marker => marker.id === markerElement.id)[0];

        markerElement.classList.remove('js-hide');

        if (filterValue === '') {
            markerElement.classList.remove('js-hidden-search');

            marker.setMap(mapObject.map);
            markersNew.push(marker);
        } else if (Array.from(markerElement.querySelectorAll('[data-searchable="true"]')).filter(x => x.textContent.toLowerCase().indexOf(filterValue.toLowerCase()) > -1).length > 0) {
            markerElement.classList.remove('js-hidden-search');

            marker.setMap(mapObject.map);
            markersNew.push(marker);
        } else {
            markerElement.classList.add('js-hidden-search');

            marker.setMap(null);
        }
    });

    if (mapObject.useCluster) {
        mapObject.cluster.clearMarkers();
        mapObject.cluster.addMarkers(markersNew);
    }

    if (mapObject.markerSearchInput) {
        markersShown(mapObject.mapContainer);
    }
}

function showUserLocation(mapObject) {
    if (navigator.geolocation) {
        const geolocationSuccess = position => {
            addUserMarker('user', 'User location', new google.maps.LatLng(position.coords.latitude, position.coords.longitude), mapObject);
            markersSort(mapObject.markerElements, 'distance');
        };

        const geolocationError = error => {
            alert(`ERROR(${error.code}): ${error.message}`);
        };

        const geolocationOptions = {
            enableHighAccuracy: true,
            timeout: 60000,
            maximumAge: Infinity
        };

        navigator.geolocation.getCurrentPosition(geolocationSuccess, geolocationError, geolocationOptions);
    }
}

/**
 * Converts degrees to radians.
 *
 * @param degrees Number of degrees.
 */
const degreesToRadians = degrees => degrees * Math.PI / 180;

/**
 * Returns the distance between 2 points of coordinates in Google Maps
 *
 * @see https://stackoverflow.com/a/1502821/4241030
 * @param lat1 Latitude of the point A
 * @param lng1 Longitude of the point A
 * @param lat2 Latitude of the point B
 * @param lng2 Longitude of the point B
 */
const getDistanceBetweenPoints = (lat1, lng1, lat2, lng2) => {
    // The radius of the planet earth in meters
    const R = 6378137;
    const dLat = degreesToRadians(lat2 - lat1);
    const dLong = degreesToRadians(lng2 - lng1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat1)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    return distance;
};
// https://ourcodeworld.com/articles/read/1021/how-to-calculate-the-distance-between-2-markers-coordinates-in-google-maps-with-javascript

/**
 * Compare retailers according to distance to the user og map center.
 */
const compareDistances = (a, b) => {
    const distanceA = getDistanceBetweenPoints(userLocation.lat, userLocation.lng, a.getAttribute('data-lat'), a.getAttribute('data-lng'));
    const distanceB = getDistanceBetweenPoints(userLocation.lat, userLocation.lng, b.getAttribute('data-lat'), b.getAttribute('data-lng'));

    if (distanceA < distanceB) {
        return -1;
    }

    if (distanceA > distanceB) {
        return 1;
    }

    return 0;
};

function addUserMarker(id, name, location, mapObject) {
    const marker = new google.maps.Marker({
        map: mapObject.map,
        icon: {
            anchor: new google.maps.Point(15, 41),
            size: new google.maps.Size(30, 41),
            url: 'data:image/svg+xml;base64,' + window.btoa('<svg xmlns="http://www.w3.org/2000/svg" width="30" height="41" viewBox="0 0 30 41"><path fill="#274733" d="M14.999 0C6.651.085-.053 6.91.012 15.258c0 4.706 2.38 10.418 7.075 16.978a74.874 74.874 0 006.963 8.368 1.34 1.34 0 001.881.021 67.481 67.481 0 006.976-8.152c4.696-6.463 7.081-12.253 7.081-17.21C30.055 6.913 23.349.085 14.999 0z"/></svg>')
        },
        id: `user-${id}`,
        position: location,
        title: name
    });

    marker.setMap(mapObject.map);
    mapObject.map.panTo(location);
    mapObject.map.setZoom(12);

    userLocation = {
        lat: location.lat(),
        lng: location.lng()
    };
}

function markersSort(markerElements, order) {
    if (order === 'distance') {
        const markersSorted = Array.from(markerElements);
        markersSorted.sort(compareDistances);

        markersSorted.forEach(marker => {
            marker.parentNode.appendChild(marker);
        });
    } else {
        markerElements.forEach(marker => {
            marker.parentNode.appendChild(marker);
        });
    }
};

function markersShowAll(mapObject) {
    mapObject.markerElements.forEach(markerElement => {
        markerElement.classList.remove('js-hide');
    });
};

function markerInfoHighlight(mapObject, id) {
    const markerElement = document.getElementById(id);

    markersInfoLowlight(mapObject);

    if (markerElement) {
        markerElement.classList.add('js-highlight');
    }
};

function markersInfoLowlight (mapObject) {
    mapObject.markerElements.forEach(markerElement => {
        markerElement.classList.remove('js-highlight');
    });
};

function addMapEvents(mapObject) {
    mapObject.map.addListener('zoom_changed', () => {
        if (mapObject.boundsFit && (!mapObject.zoomBounds || mapObject.zoomBoundsSet)) {
            mapObject.mapInteraction = true;

            if (mapObject.useInfoWindows) {
                mapObject.infoWindows.forEach(infoWindow => {
                    infoWindow.close();
                });
            }

            markersShowAll(mapObject);
        }
    });

    // Only show marker elements that has actual map markers visible on the map
    mapObject.map.addListener('bounds_changed', () => {
        if (mapObject.mapInteraction) {
            const bounds = mapObject.map.getBounds();

            mapObject.markers.forEach(marker => {
                if (bounds.contains(marker.getPosition())) {
                    document.getElementById(marker.id).classList.remove('js-hidden-bounds');
                } else {
                    document.getElementById(marker.id).classList.add('js-hidden-bounds');
                }
            });

            markersShowAll(mapObject);

            if (mapObject.markerSearchInput) {
                markersShown(mapObject.mapContainer);
            }
        }
    });

    mapObject.map.addListener('center_changed', () => {
        if (!mapObject.userLocated) {
            mapObject.userLocation = {
                lat: mapObject.map.getCenter().lat(),
                lng: mapObject.map.getCenter().lng()
            };

            markersSort(mapObject.markerElements, 'distance');
        }
    });

    mapObject.map.addListener('dragend', () => {
        mapObject.mapInteraction = true;

        markersShowAll(mapObject);
        markersInfoLowlight(mapObject);
    });
}

export function setupMaps() {
    const mapContainers = document.querySelectorAll('[data-action="map"]');
    const useClusterApi = Array.from(mapContainers).filter(x => x.hasAttribute('data-cluster')).length > 0;
    const scripts = !useClusterApi ? [`https://maps.googleapis.com/maps/api/js?v=3.53&key=${mapsApiKey}`] : [`https://maps.googleapis.com/maps/api/js?v=3.53&key=${mapsApiKey}`, 'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js'];
    const promises = [];

    scripts.forEach(script => {
        promises.push(loadScript(script));
    });

    Promise.all(promises).then(function () {
        initMaps();
    }).catch(function (script) {
        console.log(`${script} failed to load`);
    });

    /**
     * Prevent function (ex. scroll) from being executed on every call
     * @param  {Function}  callback  Callback
     * @param  {String}    delay     Delay
     * @return {Function}            Callback
     */
    const debounce = (callback, delay) => {
        let timer = null;

        return function () {
            const context = this;
            const args = arguments;

            clearTimeout(timer);

            timer = setTimeout(() => {
                callback.apply(context, args);
            }, delay);
        };
    };

    function initMaps() {
        console.log('initmaps is called');
        mapContainers.forEach(mapContainer => {
            //const mapStyles = [{'featureType': 'water','elementType': 'geometry.fill','stylers': [{'color': '#d3d3d3'}]},{'featureType': 'transit','stylers': [{'color': '#808080'},{'visibility': 'off'}]},{'featureType': 'road.highway','elementType': 'geometry.stroke','stylers': [{'visibility': 'on'},{'color': '#b3b3b3'}]},{'featureType': 'road.highway','elementType': 'geometry.fill','stylers': [{'color': '#ffffff'}]},{'featureType': 'road.local','elementType': 'geometry.fill','stylers': [{'visibility': 'on'},{'color': '#ffffff'},{'weight': 1.8}]},{'featureType': 'road.local','elementType': 'geometry.stroke','stylers': [{'color': '#d7d7d7'}]},{'featureType': 'poi','elementType': 'geometry.fill','stylers': [{'visibility': 'on'},{'color': '#ebebeb'}]},{'featureType': 'administrative','elementType': 'geometry','stylers': [{'color': '#a7a7a7'}]},{'featureType': 'road.arterial','elementType': 'geometry.fill','stylers': [{'color': '#ffffff'}]},{'featureType': 'road.arterial','elementType': 'geometry.fill','stylers': [{'color': '#ffffff'}]},{'featureType': 'landscape','elementType': 'geometry.fill','stylers': [{'visibility': 'on'},{'color': '#efefef'}]},{'featureType': 'road','elementType': 'labels.text.fill','stylers': [{'color': '#696969'}]},{'featureType': 'administrative','elementType': 'labels.text.fill','stylers': [{'visibility': 'on'},{'color': '#737373'}]},{'featureType': 'poi','elementType': 'labels.icon','stylers': [{'visibility': 'off'}]},{'featureType': 'poi','elementType': 'labels','stylers': [{'visibility': 'off'}]},{'featureType': 'road.arterial','elementType': 'geometry.stroke','stylers': [{'color': '#d6d6d6'}]},{'featureType': 'road','elementType': 'labels.icon','stylers': [{'visibility': 'off'}]},{},{'featureType': 'poi','elementType': 'geometry.fill','stylers': [{'color': '#dadada'}]}];
            const mapTarget = mapContainer.querySelector(mapContainer.getAttribute('data-target'));

            const mapObject = {
                mapContainer,
                markerElements: mapContainer.querySelectorAll('[data-action="marker"]'),
                markers: [],
                markerIcon: mapContainer.querySelector('[data-action="marker-icon"]'),
                infoWindows: [],
                useCluster: mapContainer.hasAttribute('data-cluster'),
                useInfoWindows: mapContainer.hasAttribute('data-info-windows'),
                cluster: null,
                map: new google.maps.Map(mapTarget, {
                    mapTypeId: 'roadmap',
                    //disableDefaultUI: true,
                    //draggable: false,
                    //scrollwheel: false,
                    //zoomControl: false,
                    mapTypeControl: false,
                    styles: mapStyles,
                    streetViewControl: false,
                    zoomControl: false
                }),
                bounds: new google.maps.LatLngBounds(),
                showUserLocationButton: mapContainer.querySelector('[data-action="user-location"]'),
                markerSearchInput: mapContainer.querySelector('[data-action="marker-search"]'),
                loadMarkersButton: mapContainer.querySelector('[data-action="load-markers"]'),
                userLocation: null,
                mapInteraction: false,
                boundsFit: false,
                zoomBounds: mapContainer.hasAttribute('data-zoom-bounds') ? parseInt(mapContainer.getAttribute('data-zoom-bounds')) : null,
                zoomBoundsSet: false
            };

            if (mapObject.markerElements.length > 0) {
                mapObject.markerElements.forEach(markerElement => {
                    const lat = parseFloat(markerElement.getAttribute('data-lat'));
                    const lng = parseFloat(markerElement.getAttribute('data-lng'));
                    const elementMarkerIcon = markerElement.querySelector('[data-action="marker-icon"]');

                    if (!isNaN(lat) && !isNaN(lng)) {
                        const marker = new google.maps.Marker({
                            position: {
                                lat,
                                lng
                            },
                            map: mapObject.map,
                            id: markerElement.id
                        });

                        if (elementMarkerIcon !== null) {
                            marker.setIcon({
                                anchor: new google.maps.Point(15, 41),
                                size: new google.maps.Size(30, 41),
                                url: 'data:image/svg+xml;base64,' + window.btoa(elementMarkerIcon.innerHTML)
                            });
                        } else if (mapObject.markerIcon) {
                            marker.setIcon({
                                anchor: new google.maps.Point(15, 41),
                                size: new google.maps.Size(30, 41),
                                url: 'data:image/svg+xml;base64,' + window.btoa(mapObject.markerIcon.innerHTML)
                            });
                        }

                        let infoWindow;

                        if (mapObject.useInfoWindows) {
                            const infoWindowNode = markerElement.querySelector('[data-action="info-window-content"]') ? markerElement.querySelector('[data-action="info-window-content"]') : markerElement;
                            let infoWindowContent = infoWindowNode.innerHTML;

                            if (infoWindowNode.hasAttribute('data-wrap')) {
                                infoWindowContent = `<div class="${infoWindowNode.getAttribute('data-wrap')}">${infoWindowContent}</div>`;
                            }

                            infoWindow = new google.maps.InfoWindow({
                                content: infoWindowContent,
                            });
                        }

                        marker.addListener('click', event => {
                            mapObject.mapInteraction = true;
                            mapObject.map.panTo(event.latLng);
                            markersShowAll(mapObject);
                            markerInfoHighlight(mapObject, markerElement.id);

                            if (mapObject.useInfoWindows) {
                                infoWindow.open({
                                    anchor: marker,
                                    map: mapObject.map,
                                    shouldFocus: false,
                                });

                                mapObject.infoWindows.forEach(_infoWindow => {
                                    if (_infoWindow !== infoWindow) {
                                        _infoWindow.close();
                                    }
                                });
                            }
                        });



                        mapObject.markers.push(marker);

                        if (mapObject.useInfoWindows) {
                            mapObject.infoWindows.push(infoWindow);
                        }

                        mapObject.bounds.extend(marker.position);
                    }
                });

                if (mapObject.useCluster) {
                    const clusterOptions = {
                        gridSize: 40,
                        maxZoom: 15,
                        styles: [{
                            height: 51,
                            textColor: 'black',
                            textSize: 12,
                            url: 'data:image/svg+xml;base64,' + window.btoa('<svg xmlns="http://www.w3.org/2000/svg" width="30" height="48" viewBox="0 0 30 48"><path fill="#FF8200" d="M14.999 7C6.651 7.085-.053 13.91.012 22.258c0 4.706 2.38 10.418 7.075 16.978a74.874 74.874 0 006.963 8.368 1.34 1.34 0 001.881.021 67.481 67.481 0 006.976-8.152c4.696-6.463 7.081-12.253 7.081-17.21.067-8.35-6.639-15.178-14.989-15.263z"/></svg>'),
                            width: 30
                        }]
                    };

                    console.log('breaks here')
                    mapObject.cluster = new markerClusterer.MarkerClusterer(mapObject.map, mapObject.markers, clusterOptions);
                    console.log('testing')
                }

                mapObject.map.fitBounds(mapObject.bounds);

                mapObject.map.addListener('idle', () => {
                    mapObject.boundsFit = true;

                    if (!mapObject.zoomBoundsSet) {
                        mapObject.map.setZoom(mapObject.map.getZoom() + mapObject.zoomBounds);
                        mapObject.zoomBoundsSet = true;
                    }
                });

                addMapEvents(mapObject);
            }

            if (mapObject.showUserLocationButton) {
                mapObject.showUserLocationButton.addEventListener('click', function () {
                    showUserLocation(mapObject);
                });
            }

            if (mapObject.markerSearchInput) {
                mapObject.markerSearchInput.addEventListener('keyup', debounce(function () {
                    markerSearch(mapObject);
                }, 200));
            }

            if (mapObject.loadMarkersButton) {
                mapObject.loadMarkersButton.addEventListener('click', function() {
                    loadMarkers(mapObject);
                });
            }
        });
    }
}